export default __webpack_public_path__ + "static/media/rav-zuckerman.12e1fad5.jpeg";